import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { StatusPageService } from './status-page.service';
import { CanActivateFn } from '@angular/router';

export const maintenanceGuard: CanActivateFn = () => {
    const statusPage: StatusPageService = inject(StatusPageService);
    return statusPage.checkForDowntime().pipe(map((downTime) => !downTime));
};
